module.exports = __webpack_public_path__ + "at.e006579c.svg";